import React from 'react';
import { ANIMAL_STRENGTH } from '../common/oasisCatalog.js';
import CardBackDesign from './CardBackDesign.js';

/**
 * A small inline swatch used inline in move-summary text: just the
 * animal's color and printed strength, no label (the label is written out
 * as plain text right next to it). Rendered as a small version of the real
 * face-down card (same orange, same palm-tree design) instead -- no
 * number -- whenever the animal is either genuinely unknown (a still-
 * face-down card redacted from this viewer) or known but face-down (e.g.
 * my own hidden card): either way, the icon should look face-down,
 * matching the real board.
 */
export default function MiniAnimalCard({ animal, faceDown }) {
  if (faceDown || !animal) {
    return (
      <span className="mini-animal-card mini-animal-card-back" aria-hidden="true">
        <CardBackDesign />
      </span>
    );
  }
  const strength = ANIMAL_STRENGTH[animal];
  return (
    <span className={`mini-animal-card animal-card-${animal}`} aria-hidden="true">
      {strength ?? '?'}
    </span>
  );
}
